import naja from 'naja';

/**
 * LoaderComponent is responsible for displaying a loading indicator during AJAX requests.
 *
 * This component can be deactivated in the following ways:
 * - By adding the .no-loader class to a link or button that triggers the AJAX request.
 * - By setting the data-loader="off" on the element triggering the request.
 * - By including a {noLoader: true} option in the AJAX request options when using naja.makeRequest.
 */
class LoaderComponent {
    constructor() {
        naja.addEventListener('before', this.handleBefore.bind(this));
        naja.addEventListener('complete', this.handleComplete.bind(this));
        document.addEventListener('click', event => {
            if (event.target.closest('.show-loader')) {
                this.show();
            }
        });
    }

    handleBefore(event) {
        if (this.shouldShowLoader(event.detail)) {
            this.show();
        }
    }

    handleComplete(event) {
        document.querySelectorAll('.loader').forEach(loader => loader.classList.remove('show'));
    }

    show() {
        document.querySelectorAll('.loader').forEach(loader => loader.classList.add('show'));
    }

    shouldShowLoader({element, options}) {
        // has class '.no-loader' or 'data-loader="off"'
        if (element && (element.classList.contains('no-loader') || element.dataset.loader === "off")) {
            return false;
        }

        // has option 'noLoader: true'
        return !(options && options.noLoader);
    }
}

new LoaderComponent();
